export class NoteEditor {
    constructor(fullName: string, mobilePhone?: string, userPrincipalName?: string) {
        this.fullName = fullName;
        this.mobilePhone = mobilePhone;
        this.userPrincipalName = userPrincipalName;
    }

    public readonly fullName: string;
    public readonly mobilePhone?: string;
    public readonly userPrincipalName?: string;
}
